import ApiClient from "@/domain/core/utils/apiClient"
import client_core from "@/services/clients/client_core"

const client = new ApiClient(client_core)

const endpoint = '/dashboard/v3/media/download/'

export default {
    async download({media, options} = {}) {
        return await client.post(endpoint, {media, options: options || {}})
    },
}
